import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue';
import { useCustomToast } from './useCustomToast';

export interface TableStateConfig<T = unknown> {
  error?: MaybeRefOrGetter<string | null | undefined>;
  data?: MaybeRefOrGetter<readonly T[] | null | undefined>;
  loading?: MaybeRefOrGetter<boolean | undefined>;
  errorTitle?: string;
  errorMessage?: string;
  emptyMessage?: string;
}

export interface TableState {
  shouldShowError: ComputedRef<boolean>;
  shouldShowEmpty: ComputedRef<boolean>;
  shouldShowData: ComputedRef<boolean>;
  handleErrorToast: () => void;
}

export function useTableState<T = unknown>(config: TableStateConfig<T>): TableState {
  const toast = useCustomToast();

  const shouldShowError = computed((): boolean => Boolean(toValue(config.error)));

  const shouldShowEmpty = computed((): boolean => {
    const error = toValue(config.error);
    const loading = toValue(config.loading);
    const data = toValue(config.data);
    return !error && !loading && (!data || data.length === 0);
  });

  const shouldShowData = computed((): boolean => {
    const error = toValue(config.error);
    const loading = toValue(config.loading);
    const data = toValue(config.data);
    return !error && !loading && Boolean(data && data.length > 0);
  });

  const handleErrorToast = () => {
    const error = toValue(config.error);
    if (error) {
      toast.showErrorToast({
        title: config.errorTitle || 'Erro',
        message: config.errorMessage || error,
        type: 'error',
      });
    }
  };

  return {
    shouldShowError,
    shouldShowEmpty,
    shouldShowData,
    handleErrorToast,
  };
}